import { create } from "zustand";
import { api } from "./api";
import { fmt } from "./format";

export const useCommunity = create((set) => ({
  info: null,
  prompt: null,
  sheet: null,
  load: () => api.get("/community").then((r) => set({ info: r.data })).catch(() => {}),
  setPrompt: (prompt) => set({ prompt }),
  openSheet: (sheet) => set({ sheet, prompt: null }),
  closeSheet: () => set({ sheet: null }),
}));

const KEY = "gw_share_prompted";

export function markPrompted(id) {
  let seen = [];
  try { seen = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { seen = []; }
  if (seen.includes(id)) return false;
  localStorage.setItem(KEY, JSON.stringify([...seen.slice(-199), id]));
  return true;
}

export const signedPct = (v) => `${v > 0 ? "+" : ""}${Number(v).toFixed(2)}%`;
export const tgShareUrl = (url, text) => `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;

export function captionFor(card, showAmount) {
  if (card.kind === "win") {
    const res = showAmount ? `+₹${fmt(card.pnl)} (${signedPct(card.pct)})` : signedPct(card.pct);
    return `Booked ${res} on ${card.symbol} today ✅ Trading with Greenwick Funded.`;
  }
  return `Taking ${card.side} ${card.symbol} @ ₹${fmt(card.entry)}${card.sl ? `, SL ₹${fmt(card.sl)}` : ""} 📈 Trading with Greenwick Funded.`;
}

export async function openShareFor({ orderId, positionId }) {
  const { data } = await api.get(positionId ? `/community/position/${positionId}` : `/community/order/${orderId}`);
  if (data.kind !== "trade" && data.kind !== "win") throw new Error("Only live trades and profitable trades can be shared");
  useCommunity.getState().openSheet({ card: data, positionId });
}

export const sourceOf = (sheet) => (sheet.positionId ? { position_id: sheet.positionId } : { order_id: sheet.card.trade_id });
